$(document).ready(function () {
    let porcentajesUuid = null;

    $("#table-campigns tbody").on('click', '.add-porcentajes-to-campaign', function () {
        porcentajesUuid = $(this).data('uuid');
        let description = $(this).data('description');

        if ($.fn.DataTable.isDataTable('#table-campaign-porcentajes')) {
            $('#table-campaign-porcentajes').DataTable().clear().destroy();
        }

        $(".modal-title-porcentajes").html('Agregar registro - ' + description);
        $("#item-uuid-porcentajes").val(porcentajesUuid);
        $("#item-monto").val('');
        $("#item-porcentaje-tramo").val('');
        $("#modal-campaign-porcentajes").modal('show');
    });

    $('#modal-campaign-porcentajes').on('shown.bs.modal', function () {
        if (!porcentajesUuid) {
            return;
        }
        loadPorcentajesTable(porcentajesUuid);
    });

    $('#modal-campaign-porcentajes').on('hidden.bs.modal', function () {
        if ($.fn.DataTable.isDataTable('#table-campaign-porcentajes')) {
            $('#table-campaign-porcentajes').DataTable().clear().destroy();
        }
        porcentajesUuid = null;
    });

    function loadPorcentajesTable(uuid) {
        $("#table-campaign-porcentajes").DataTable({
            processing: true,
            serverSide: true,
            autoWidth: false,
            language: {
                "url": "//cdn.datatables.net/plug-ins/1.10.16/i18n/Spanish.json"
            },
            ajax: 'get-porcentajes-by-campaign/' + uuid,
            columns: [
                {
                    data: 'monto',
                    name: 'monto',
                    render: function (data) {
                        return parseFloat(data).toFixed(2);
                    }
                },
                {
                    data: 'porcentaje',
                    name: 'porcentaje',
                    render: function (data) {
                        return parseFloat(data).toFixed(2);
                    }
                },
                {
                    data: 'id',
                    name: 'id',
                    orderable: false,
                    searchable: false,
                    render: function (data) {
                        return '<button class="btn btn-danger delete-porcentaje-tramo m-1 btn-sm" ' +
                            'data-id="' + data + '"><i class="fa-solid fa-trash-can"></i></button>';
                    }
                }
            ],
            drawCallback: function () {
                this.api().columns.adjust();
            }
        });
    }

    $("#add-porcentaje-tramo").on('click', function () {
        let data = new FormData();
        data.append('uuid', $("#item-uuid-porcentajes").val());
        data.append('monto', $("#item-monto").val());
        data.append('porcentaje', $("#item-porcentaje-tramo").val());
        sendPorcentajeData('add-porcentaje', data);
    });

    $("#table-campaign-porcentajes tbody").on('click', '.delete-porcentaje-tramo', function () {
        let data = new FormData();
        data.append('uuid', $("#item-uuid-porcentajes").val());
        data.append('id', $(this).data('id'));

        Swal.fire({
            title: "¿Está seguro de eliminar el registro?",
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: "Sí, eliminar",
            cancelButtonText: "Cancelar",
            customClass: {
                confirmButton: 'laproveedora_btn'
            }
        }).then(resultado => {
            if (resultado.value) {
                sendPorcentajeData('delete-porcentaje', data);
            }
        });
    });

    function sendPorcentajeData(route, data) {
        togglePreloader();
        $.ajax({
            url: route,
            type: "post",
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (response) {
                togglePreloader();
                if (response.type === "error" || response.type === "errorConnection") {
                    alertError(response.msg);
                    return;
                }

                $("#item-monto").val('');
                $("#item-porcentaje-tramo").val('');
                if ($.fn.DataTable.isDataTable('#table-campaign-porcentajes')) {
                    $("#table-campaign-porcentajes").DataTable().ajax.reload(null, false);
                }
                alertSuccess(response.msg);
                if (response.msgError) {
                    alertError(response.msgError);
                }
            },
            error: function (errors) {
                togglePreloader();
                if (errors.responseJSON && errors.responseJSON.errors) {
                    let message = Object.values(errors.responseJSON.errors).flat().join('<br>');
                    alertError(message);
                }
            }
        });
    }
});
